module.exports = __webpack_public_path__ + "img/q-img-1.937b7a57.png";